// extracted by mini-css-extract-plugin
module.exports = {"indicator_focused":"_-_-pharmacy-src-input-select-components__indicator_focused--3Kzr1"};